module.exports = __webpack_public_path__ + "img/serive3.35d77fce.jpg";